import { transactionsProcessingTypes, transactionsProcessingUtils } from 'app-components/flux/transactions-processing';
import store from 'app-components/utils/redux-store';
import type { GuidedPopoverState } from 'components/guides/FutureTransactionGuidedPopover';
import { setGuidedPopoverState } from 'components/guides/FutureTransactionGuidedPopover';
import type { Store } from 'redux';

import { projectedBalancesId } from 'components/ProjectedBalances/constants';
import type { FeaturePage } from 'containers/App/paths';
import { getNavFromKey, makeNavigationItemId, upcomingNavKey } from 'containers/App/paths';

const projectedBalancesSelector = `#${projectedBalancesId}`;
const upcomingNavMenuSelector = `#${makeNavigationItemId(getNavFromKey(upcomingNavKey) as FeaturePage)} span`;

const getPopoverPositionProps = (guide: transactionsProcessingTypes.Guide) => {
  switch (guide) {
    case transactionsProcessingTypes.Guide.FUTURE_TXN_CREATED:
      {
        const projectedBalancesRootEl = document.querySelector(projectedBalancesSelector);
        if (projectedBalancesRootEl) {
          return {
            anchorEl: projectedBalancesRootEl,
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          };
        }

        const navMenuBillsPaymentsEl = document.querySelector(upcomingNavMenuSelector);
        if (navMenuBillsPaymentsEl) {
          return {
            anchorEl: navMenuBillsPaymentsEl,
            placement: 'right',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 32],
                },
              },
            ],
          };
        }
      }

      return null;
  }

  return null;
};

const getPopoverProps = (guide: transactionsProcessingTypes.Guide, store: Store): GuidedPopoverState | null => {
  const positionProps = getPopoverPositionProps(guide);

  if (!positionProps) {
    assert(false, `No anchor could be found for the ${guide} guide.`);
    return null;
  }

  switch (guide) {
    case transactionsProcessingTypes.Guide.FUTURE_TXN_CREATED:
      return {
        title: 'You created a Reminder',
        body: 'Future transactions in Simplifi show up as Reminders. You can view them in any of the Reminder trays, or under Bills & Income.',
        ...positionProps,
        onDoNotShowAgain: () => {
          transactionsProcessingUtils.dontShowGuideAgain(store.dispatch, store.getState(), guide);
        },
      };
  }

  return null;
};

export const processGuides = (guides: transactionsProcessingTypes.Guide[]) => {
  if (!store) {
    assert(false, 'store is null in processGuides function');
    return;
  }

  const nonNullStore = store;

  assert(guides.length <= 1, 'Currently only one guide can be shown at a time.');

  if (guides.length) {
    const props = getPopoverProps(guides[0], nonNullStore);
    setGuidedPopoverState(props);
  }
};
